import Avatar from '@mui/material/Avatar';
import logo from '../images/logo-plain.png'

export const Hero = () => {
  return (
    <img
      alt="Babel Chat logo"
      src={logo}
      style={{
        width: '80px',
        height: '80px',
        marginTop: '40px',
        marginBottom: '20px',
      }}
    />
  )
}

export default Hero
